import { datadogRum } from '@datadog/browser-rum'
import { Service, service } from './di'

@service('datadogRumService')
export class DatadogRumService extends Service {
    init() {
        datadogRum.init({
            applicationId: 'a3779053-4901-4798-a6e2-f8a3eb080a83',
            clientToken: 'pub610603d8859b5de3f81af63eec6c1a98',
            site: 'datadoghq.com',
            service: 'flipp-web---legacy',
            env: 'production',
            sessionSampleRate: 1,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
        })
    }

    logError(e: any, context: any) {
        datadogRum.addError(e, context)
    }
}
